import { MetaDefinition } from '../../services/metadata/meta-types';
import { InputHandler } from '../input-handler';
import { Tool } from './tool';

export class OnDemandTool extends Tool {
  private meta: MetaDefinition;

  enable() {
    this.visible = true;
    this.inputHandler.setCursor('default');
  }

  constructor(inputHandler: InputHandler) {
    super('on-demand', inputHandler);
    this.visible = false;
    this.meta = { src: 'tool.on-demand', parameters: [] };
  }

  getMeta(sweref?: string): MetaDefinition {
    return this.meta;
  }
}
